const elButtonThrottle = {
  inserted: function (el, binding) {
    let lastTime = 0
    el.addEventListener('click', function () {
      const nowTime = new Date().getTime()
      if (nowTime - lastTime > 1000) {
        lastTime = nowTime
        binding.value()
      }
    })
  },
}

const install = function (Vue) {
  Vue.directive('throttle', elButtonThrottle)
}

if (window.Vue) {
  window.Vue.use(install)
}

elButtonThrottle.install = install

export default elButtonThrottle
